module.exports = __webpack_public_path__ + "img/bot-link.2c2ebac4.png";